import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'stops'
})
// The work of the pipe is handled in the tranform method with our pipe's class
export class Stops implements PipeTransform {
  transform(value: String, args: any[]) {
    return +value > 1 ? value + ' arrêts' : value + ' arrêt'
  }
}
